export default "__VITE_ASSET__BzxTunwX__"